export default __webpack_public_path__ + "static/media/landingPagePoints.50e4030f.svg";